import DOMPurify from 'dompurify';
import * as styles from './styles/style.module.scss';

type Props = {
  // Typically a string with (or without) HTML from Algolia.
  highlightedName: string;
};

const HighlightedResultName = ({ highlightedName }: Props) => {
  const sanitizeConfig = {
    // Only allow <em> tags from Algolia, which Algolia uses to highlight text.
    // https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/highlighting-snippeting/js/#pre--and-post-tags
    ALLOWED_TAGS: ['em']
  };

  // Algolia explicitly puts the onus on users to sanitize the HTML they return.
  // https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/highlighting-snippeting/js/#sanitization-of-the-results
  // We could try to replicate what Algolia already does and generate our own
  // HTML rather than sanitizing theirs. They do return the raw data for what
  // values constitute a highlight, but if they update their highlighting
  // logic we could drift from what they're doing and we might end up creating a
  // worse/less efficient experience. We'd probably still need to set innerHTML
  // even if we did it ourselves.
  const sanitizedString = DOMPurify.sanitize(highlightedName, sanitizeConfig);

  // We should never normally set innerHTML like this, but Algolia already does the
  // work to highlight a result with HTML for us and the raw data they return
  // would be difficult to morph into the same HTML they give us for free. Even if
  // we mangled the raw response data from Algolia into the same representation
  // for highlighting we would almost certainly need to still set inner HTML.
  // eslint-disable-next-line react/no-danger
  return <span className={styles.name} dangerouslySetInnerHTML={{ __html: sanitizedString }} />;
};

export default HighlightedResultName;
